import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ROUTER_NAVIGATED, RouterNavigatedAction } from '@ngrx/router-store';
import { SearchActions } from '@search/data-access';
import { ActivatedRouterStateSnapshot, ProductActions, RoutingService } from '@spartacus/core';
import { Observable, merge } from 'rxjs';
import { filter, map, switchMap, take, tap } from 'rxjs/operators';
import { AnyQueryAnalyticsService, RetailRocketService, SearchAnalyticsService } from '../services';

@Injectable()
export class SearchAnalyticsEffects {
  searchNavigated$: Observable<void> = createEffect(
    () =>
      merge(
        // Если зашли сразу на страницу поиска
        this.actions$.pipe(
          ofType(ROUTER_NAVIGATED),
          take(1),
          map(({ payload }: RouterNavigatedAction<ActivatedRouterStateSnapshot>) => payload.routerState),
          filter(({ semanticRoute, params: { query } }) => semanticRoute === 'search' && !!query),
          map(({ params: { query } }) => query as string),
        ),
        // Если начали искать
        this.actions$.pipe(
          ofType(SearchActions.SEARCH_LAUNCH),
          map(({ payload }) => payload as string),
        ),
      ).pipe(
        tap((searchText: string) => this.retailRocketService.onLaunchSearch({ searchText })),
        map(() => undefined),
      ),
    { dispatch: false },
  );

  launchSearch$: Observable<void> = createEffect(
    () =>
      this.actions$.pipe(
        ofType(SearchActions.SEARCH_LAUNCH),
        map(({ payload }) => payload as string),
        tap((searchText: string) => this.searchAnalyticsService.onLaunchSearch(searchText)),
        map(() => undefined),
      ),
    { dispatch: false },
  );

  onViewProductList$: Observable<void> = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ProductActions.SEARCH_PRODUCTS_SUCCESS),
        switchMap((action) =>
          this.routingService.isNavigating().pipe(
            filter((isNavigating) => !isNavigating),
            take(1),
            map(() => action),
          ),
        ),
        map(({ payload: { products, freeTextSearch }, auxiliary }: ProductActions.SearchProductsSuccess) => ({
          products,
          auxiliary,
          freeTextSearch,
        })),
        filter(
          ({ products, auxiliary, freeTextSearch }) =>
            Boolean(products?.length) && !auxiliary && Boolean(freeTextSearch),
        ),
        tap(({ products, freeTextSearch }) => {
          this.anyQueryAnalyticsService.onSearchPage({
            query: freeTextSearch,
            productCodes: products.map(({ code }) => code),
          });
        }),
        map(() => undefined),
      ),
    { dispatch: false },
  );

  constructor(
    private actions$: Actions,
    private retailRocketService: RetailRocketService,
    private searchAnalyticsService: SearchAnalyticsService,
    private anyQueryAnalyticsService: AnyQueryAnalyticsService,
    private routingService: RoutingService,
  ) {}
}
